export const MESSAGE_ERRORS = 'MESSAGE_ERRORS';
export const MESSAGE_ERRORS_CLEAR = 'MESSAGE_ERRORS_CLEAR';
export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS';
export const MESSAGE_SUCCESS_CLEAR = 'MESSAGE_SUCCESS_CLEAR';
export const MESSAGE_HIDE = 'MESSAGE_HIDE';